import CacheService from '../cache-service';
const axios = require('axios');

class TrendingNewsService extends CacheService {
  getNewsById(id) {
    return this.getCachedData(`/api/trending-news/${id}`);
  }
}

const trendingNewsService = new TrendingNewsService();

export default trendingNewsService;